import React, { useContext } from 'react'
import OrderConfirmation from '../../Components/OrderConfirmation/OrderConfirmation'
import { ShopContext } from '../../Context/ShopContext';



const Order = () => {

    const {selectedItems} = useContext(ShopContext);

if(selectedItems.length === 0){
    return window.location.replace("/cart");
}

  return (
    <div>
      <OrderConfirmation/>
    </div>
  )
}

export default Order
